// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#video{
  width: 100%;
  /* height: 100%; */
  text-align: center;
  vertical-align: center;
}

#my-button{
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 10px;
  z-index: 1000;
}

.jiggle {
  -webkit-animation: jiggle 0.2s infinite;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: jiggle;
  -moz-animation-iteration-count: infinite;
  -webkit-transform: rotate(-3deg);
  -moz-transform: rotate(-3deg);
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}

@-moz-keyframes jiggle {
  0% {
      -moz-transform: rotate(-1deg);

  }
  50% {
      -moz-transform: rotate(1deg);
  }
}


@-webkit-keyframes jiggle {
  0% {
      -webkit-transform: rotate(-1deg);
      /* opacity: 1; */
      }
  50% {
      -webkit-transform: rotate(1deg);
      /* opacity: 0; */
  }
}

@-webkit-keyframes fadeOut {
  0% {opacity: 1;}
  100% {opacity: 0;}
}

@-moz-keyframes fadeOut {
  0% {opacity: 1;}
  100% {opacity: 0;}
}


@keyframes fadeOut {
  0% {opacity: 1;}
  100% {opacity: 0;}
}


.animated{
  -webkit-animation-duration: 7s;animation-duration: 7s;
  -webkit-animation-fill-mode: both;animation-fill-mode: both;
}


#thingmoji_temp{
  position: absolute;
  z-index: 200;
  width: 115px;
  height: 115px;
  margin: 2px;
  /* height: 100%; */
  bottom: 0px;
  /* right:0px; */
  cursor: pointer;
  /* background-color: rgba(255,255,255,0.3); */
  /* add animation of the transparency*/
}
.float-thingmoji{
  position: absolute; 
  display: none;
  top: 0px; 
  left: 80px;
  transform: translateX(-50%);
  width: 120px; 
  height: 120px;
  border-radius: 10px;
  background-color: white;
  border: 1px solid #ccc;
  padding: 2px;
  z-index: 1000;
}
.float-thingmoji span{
  content: '';
  position: absolute;
  right: -20px;
  /* top:var(--pseudo-top); */
  /* left: 50%; */
  top:25%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  border-left: 10px solid lightcoral;    
  /* border-left: 30px solid transparent;
  border-right: 30px solid transparent;
  border-top: 10px solid lightcoral;     */
  /* width: 120px; 
  height: auto; */
  /* border-bottom: var(--pseudo-border-bottom); */
  /* add hover  */
  /* transition: all 0.3s ease-in-out; */
}

/* #float-thingmoji::after:hover{
  transform: scale(1.2)

} */


#float-box{
  width: 350px;
  height: 200px;
  /* width:100%; */
  /* height:200px; */
  margin: 2px;
  /* background-color: black; */
  /* opacity: 0.5; */
  bottom: 0px;
  right: 0px;
  position: relative;
  z-index: 200;
  border: 1px solid gray;
  border-radius: 5px;
  cursor: crosshair;
}

#thumbnailsContainer img {
  width: 50px; /* or whatever size you prefer */
  height: 50px;
  object-fit: cover; /* this will ensure the image covers the dimensions without distortion */
  display: inline-block;
  position: relative;
}




#modify{
  z-index: 201;
  position: relative;
  width: 100px;
  left: -50px;
  top: -100px;
}

.float-thingmoji{
  /* width: 100px;
  height: 100px; */
  margin: 2px;
  /* background-color: black; */
  /* opacity: 0.5; */
  top: -120px;
  /* right: 0px; */
  position: absolute;
  z-index: 200;
  /* border: 1px solid black; */
  /* border-radius: 1%; */
  /* cursor: crosshair; */
} */


#image-finded{
  position: absolute;
  z-index: 100;
  width: 100%;
  /* height: 100%; */
  top: 0px;
  background-color: rgba(255,255,255,0.3);
}

#keyframe{
  visibility: hidden;
}

#contentEditable:hover{
  border: 1px solid gray;
}

/* #message-selected{

} */
#myWhiteboard{
  position: absolute;
  cursor: crosshair;
  z-index: 150;
}

#mypeekwindow{
  z-index: 0;
  position: absolute;
  cursor: crosshair;
}

#page{
  height:100vh;
  width: 100%;
  /* padding: 10px; */
  display: grid;
  grid-template-areas: 
  'header header'
  'videopanel textarea'
  'bar textarea';
  grid-template-rows: min-content 10fr 0.5fr;
  grid-template-columns: 8fr 3fr;
}


#header{
  grid-area: header;
  width: 100%;
  text-align: center;
  vertical-align: center;
  height: min-content;
  margin: 0;
}

#videocontainer{
  left:10px;
  position: absolute;
  right: 100%;
  width: 70%;
  height: 87%;
  top: 5%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 1%;
  grid-area: videopanel;
  background-color: black;
}

#textspan{
  width: 70%;
  word-wrap: break-word;
  /* white-space: pre-wrap; */
  inline-size: 150px;
}

select {
  max-width: 200px;
  -webkit-appearance: button;
  -moz-appearance: button;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-padding-end: 20px;
  -moz-padding-end: 20px;
  -webkit-padding-start: 2px;
  -moz-padding-start: 2px;
  /* background-color: #282c34; Fallback color if gradients are not supported */
  background-color:  #212529;
  opacity: 0.7;
  /* background-position: center right;
  background-repeat: no-repeat; */
  border: 0;
  /* border-radius: 2px; */
  /* box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1); */
  color: white;
  font-size: inherit;
  /* margin: 0; */
  overflow: hidden;
  /* padding-top: 2px;
  padding-bottom: 2px; */
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 5px;
  font-size: 15px;
  padding: 12px;
  /* border-radius: 5px; */
  margin: 1px;
}

#chatboxcontainer{
  position: absolute;
  display: flex;
  /* top: 0px; */
  height: 95%;
  right:10px;
  width: 28%;
  grid-area: textarea;
}

.thumbnail:hover{
 transform: scale(1.2);
}



/* loginform */
input[type=text], input[type=password] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

/* Set a style for all buttons */
/* button {
  background-color: #04AA6D;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
} */

button:hover {
  opacity: 0.8;
}

/* Extra styles for the cancel button */
.cancelbtn {
  width: auto;
  padding: 10px 18px;
  background-color: #f44336;
}

/* Center the image and position the close button */
.imgcontainer {
  text-align: center;
  margin: 24px 0 12px 0;
  position: relative;
}

img.avatar {
  width: 40%;
  border-radius: 50%;
}

.container {
  padding: 16px;
}

span.psw {
  float: right;
  padding-top: 16px;
}

/* The Modal (background) */
.modal {
  display: block; 
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  padding-top: 60px;
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 5% auto 15% auto; /* 5% from the top, 15% from the bottom and centered */
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
}
`, "",{"version":3,"sources":["webpack://./src/routes/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,2BAA2B;EAC3B,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE;MACI,6BAA6B;;EAEjC;EACA;MACI,4BAA4B;EAChC;AACF;;;AAGA;EACE;MACI,gCAAgC;MAChC,gBAAgB;MAChB;EACJ;MACI,+BAA+B;MAC/B,gBAAgB;EACpB;AACF;;AAEA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;AACnB;;AAEA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;AACnB;;;AAGA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;AACnB;;;AAGA;EACE,8BAA8B,CAAC,sBAAsB;EACrD,iCAAiC,CAAC,yBAAyB;AAC7D;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,OAAO;EACP,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,kCAAkC;EAClC;;0CAEwC;EACxC;iBACe;EACf,gDAAgD;EAChD,eAAe;EACf,sCAAsC;AACxC;;AAEA;;;GAGG;;;AAGH;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW,EAAE,gCAAgC;EAC7C,YAAY;EACZ,iBAAiB,EAAE,wEAAwE;EAC3F,qBAAqB;EACrB,kBAAkB;AACpB;;;;;AAKA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE;kBACgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;AACzB,EAAE;;;;EAIA,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb;;;gBAGc;EACd,0CAA0C;EAC1C,8BAA8B;AAChC;;;AAGA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,6EAA6E;EAC7E,0BAA0B;EAC1B,YAAY;EACZ;iCAC+B;EAC/B,SAAS;EACT,wBAAwB;EACxB,gDAAgD;EAChD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;wBACsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iHAAiH;EACjH,sNAAsN;EACtN,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;;;AAIA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;;;;;;;;GAQG;;AAEH;EACE,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,eAAe,EAAE,kBAAkB;EACnC,UAAU,EAAE,eAAe;EAC3B,OAAO;EACP,MAAM;EACN,WAAW,EAAE,eAAe;EAC5B,YAAY,EAAE,gBAAgB;EAC9B,cAAc,EAAE,4BAA4B;EAC5C,4BAA4B,EAAE,mBAAmB;EACjD,iCAAiC,EAAE,qBAAqB;EACxD,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,wBAAwB,EAAE,sDAAsD;EAChF,sBAAsB;EACtB,UAAU,EAAE,oDAAoD;AAClE","sourcesContent":["#video{\r\n  width: 100%;\r\n  /* height: 100%; */\r\n  text-align: center;\r\n  vertical-align: center;\r\n}\r\n\r\n#my-button{\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  margin: 10px;\r\n  z-index: 1000;\r\n}\r\n\r\n.jiggle {\r\n  -webkit-animation: jiggle 0.2s infinite;\r\n  -moz-animation-duration: 0.2s;\r\n  -moz-animation-name: jiggle;\r\n  -moz-animation-iteration-count: infinite;\r\n  -webkit-transform: rotate(-3deg);\r\n  -moz-transform: rotate(-3deg);\r\n}\r\n\r\n.fadeOut {\r\n  -webkit-animation-name: fadeOut;\r\n  animation-name: fadeOut;\r\n}\r\n\r\n@-moz-keyframes jiggle {\r\n  0% {\r\n      -moz-transform: rotate(-1deg);\r\n\r\n  }\r\n  50% {\r\n      -moz-transform: rotate(1deg);\r\n  }\r\n}\r\n\r\n\r\n@-webkit-keyframes jiggle {\r\n  0% {\r\n      -webkit-transform: rotate(-1deg);\r\n      /* opacity: 1; */\r\n      }\r\n  50% {\r\n      -webkit-transform: rotate(1deg);\r\n      /* opacity: 0; */\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeOut {\r\n  0% {opacity: 1;}\r\n  100% {opacity: 0;}\r\n}\r\n\r\n@-moz-keyframes fadeOut {\r\n  0% {opacity: 1;}\r\n  100% {opacity: 0;}\r\n}\r\n\r\n\r\n@keyframes fadeOut {\r\n  0% {opacity: 1;}\r\n  100% {opacity: 0;}\r\n}\r\n\r\n\r\n.animated{\r\n  -webkit-animation-duration: 7s;animation-duration: 7s;\r\n  -webkit-animation-fill-mode: both;animation-fill-mode: both;\r\n}\r\n\r\n\r\n#thingmoji_temp{\r\n  position: absolute;\r\n  z-index: 200;\r\n  width: 115px;\r\n  height: 115px;\r\n  margin: 2px;\r\n  /* height: 100%; */\r\n  bottom: 0px;\r\n  /* right:0px; */\r\n  cursor: pointer;\r\n  /* background-color: rgba(255,255,255,0.3); */\r\n  /* add animation of the transparency*/\r\n}\r\n.float-thingmoji{\r\n  position: absolute; \r\n  display: none;\r\n  top: 0px; \r\n  left: 80px;\r\n  transform: translateX(-50%);\r\n  width: 120px; \r\n  height: 120px;\r\n  border-radius: 10px;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  padding: 2px;\r\n  z-index: 1000;\r\n}\r\n.float-thingmoji span{\r\n  content: '';\r\n  position: absolute;\r\n  right: -20px;\r\n  /* top:var(--pseudo-top); */\r\n  /* left: 50%; */\r\n  top:25%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 30px solid transparent;\r\n  border-bottom: 30px solid transparent;\r\n  border-left: 10px solid lightcoral;    \r\n  /* border-left: 30px solid transparent;\r\n  border-right: 30px solid transparent;\r\n  border-top: 10px solid lightcoral;     */\r\n  /* width: 120px; \r\n  height: auto; */\r\n  /* border-bottom: var(--pseudo-border-bottom); */\r\n  /* add hover  */\r\n  /* transition: all 0.3s ease-in-out; */\r\n}\r\n\r\n/* #float-thingmoji::after:hover{\r\n  transform: scale(1.2)\r\n\r\n} */\r\n\r\n\r\n#float-box{\r\n  width: 350px;\r\n  height: 200px;\r\n  /* width:100%; */\r\n  /* height:200px; */\r\n  margin: 2px;\r\n  /* background-color: black; */\r\n  /* opacity: 0.5; */\r\n  bottom: 0px;\r\n  right: 0px;\r\n  position: relative;\r\n  z-index: 200;\r\n  border: 1px solid gray;\r\n  border-radius: 5px;\r\n  cursor: crosshair;\r\n}\r\n\r\n#thumbnailsContainer img {\r\n  width: 50px; /* or whatever size you prefer */\r\n  height: 50px;\r\n  object-fit: cover; /* this will ensure the image covers the dimensions without distortion */\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n\r\n\r\n\r\n#modify{\r\n  z-index: 201;\r\n  position: relative;\r\n  width: 100px;\r\n  left: -50px;\r\n  top: -100px;\r\n}\r\n\r\n.float-thingmoji{\r\n  /* width: 100px;\r\n  height: 100px; */\r\n  margin: 2px;\r\n  /* background-color: black; */\r\n  /* opacity: 0.5; */\r\n  top: -120px;\r\n  /* right: 0px; */\r\n  position: absolute;\r\n  z-index: 200;\r\n  /* border: 1px solid black; */\r\n  /* border-radius: 1%; */\r\n  /* cursor: crosshair; */\r\n} */\r\n\r\n\r\n#image-finded{\r\n  position: absolute;\r\n  z-index: 100;\r\n  width: 100%;\r\n  /* height: 100%; */\r\n  top: 0px;\r\n  background-color: rgba(255,255,255,0.3);\r\n}\r\n\r\n#keyframe{\r\n  visibility: hidden;\r\n}\r\n\r\n#contentEditable:hover{\r\n  border: 1px solid gray;\r\n}\r\n\r\n/* #message-selected{\r\n\r\n} */\r\n#myWhiteboard{\r\n  position: absolute;\r\n  cursor: crosshair;\r\n  z-index: 150;\r\n}\r\n\r\n#mypeekwindow{\r\n  z-index: 0;\r\n  position: absolute;\r\n  cursor: crosshair;\r\n}\r\n\r\n#page{\r\n  height:100vh;\r\n  width: 100%;\r\n  /* padding: 10px; */\r\n  display: grid;\r\n  grid-template-areas: \r\n  'header header'\r\n  'videopanel textarea'\r\n  'bar textarea';\r\n  grid-template-rows: min-content 10fr 0.5fr;\r\n  grid-template-columns: 8fr 3fr;\r\n}\r\n\r\n\r\n#header{\r\n  grid-area: header;\r\n  width: 100%;\r\n  text-align: center;\r\n  vertical-align: center;\r\n  height: min-content;\r\n  margin: 0;\r\n}\r\n\r\n#videocontainer{\r\n  left:10px;\r\n  position: absolute;\r\n  right: 100%;\r\n  width: 70%;\r\n  height: 87%;\r\n  top: 5%;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 1%;\r\n  grid-area: videopanel;\r\n  background-color: black;\r\n}\r\n\r\n#textspan{\r\n  width: 70%;\r\n  word-wrap: break-word;\r\n  /* white-space: pre-wrap; */\r\n  inline-size: 150px;\r\n}\r\n\r\nselect {\r\n  max-width: 200px;\r\n  -webkit-appearance: button;\r\n  -moz-appearance: button;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -webkit-padding-end: 20px;\r\n  -moz-padding-end: 20px;\r\n  -webkit-padding-start: 2px;\r\n  -moz-padding-start: 2px;\r\n  /* background-color: #282c34; Fallback color if gradients are not supported */\r\n  background-color:  #212529;\r\n  opacity: 0.7;\r\n  /* background-position: center right;\r\n  background-repeat: no-repeat; */\r\n  border: 0;\r\n  /* border-radius: 2px; */\r\n  /* box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1); */\r\n  color: white;\r\n  font-size: inherit;\r\n  /* margin: 0; */\r\n  overflow: hidden;\r\n  /* padding-top: 2px;\r\n  padding-bottom: 2px; */\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\r\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  border-radius: 5px;\r\n  font-size: 15px;\r\n  padding: 12px;\r\n  /* border-radius: 5px; */\r\n  margin: 1px;\r\n}\r\n\r\n#chatboxcontainer{\r\n  position: absolute;\r\n  display: flex;\r\n  /* top: 0px; */\r\n  height: 95%;\r\n  right:10px;\r\n  width: 28%;\r\n  grid-area: textarea;\r\n}\r\n\r\n.thumbnail:hover{\r\n transform: scale(1.2);\r\n}\r\n\r\n\r\n\r\n/* loginform */\r\ninput[type=text], input[type=password] {\r\n  width: 100%;\r\n  padding: 12px 20px;\r\n  margin: 8px 0;\r\n  display: inline-block;\r\n  border: 1px solid #ccc;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Set a style for all buttons */\r\n/* button {\r\n  background-color: #04AA6D;\r\n  color: white;\r\n  padding: 14px 20px;\r\n  margin: 8px 0;\r\n  border: none;\r\n  cursor: pointer;\r\n  width: 100%;\r\n} */\r\n\r\nbutton:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Extra styles for the cancel button */\r\n.cancelbtn {\r\n  width: auto;\r\n  padding: 10px 18px;\r\n  background-color: #f44336;\r\n}\r\n\r\n/* Center the image and position the close button */\r\n.imgcontainer {\r\n  text-align: center;\r\n  margin: 24px 0 12px 0;\r\n  position: relative;\r\n}\r\n\r\nimg.avatar {\r\n  width: 40%;\r\n  border-radius: 50%;\r\n}\r\n\r\n.container {\r\n  padding: 16px;\r\n}\r\n\r\nspan.psw {\r\n  float: right;\r\n  padding-top: 16px;\r\n}\r\n\r\n/* The Modal (background) */\r\n.modal {\r\n  display: block; \r\n  position: fixed; /* Stay in place */\r\n  z-index: 1; /* Sit on top */\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%; /* Full width */\r\n  height: 100%; /* Full height */\r\n  overflow: auto; /* Enable scroll if needed */\r\n  background-color: rgb(0,0,0); /* Fallback color */\r\n  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\r\n  padding-top: 60px;\r\n}\r\n\r\n/* Modal Content/Box */\r\n.modal-content {\r\n  background-color: #fefefe;\r\n  margin: 5% auto 15% auto; /* 5% from the top, 15% from the bottom and centered */\r\n  border: 1px solid #888;\r\n  width: 80%; /* Could be more or less, depending on screen size */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
